import { render } from "./PlenumSelector.vue?vue&type=template&id=4d5db025&scoped=true"
import script from "./PlenumSelector.vue?vue&type=script&lang=js"
export * from "./PlenumSelector.vue?vue&type=script&lang=js"

import "./PlenumSelector.vue?vue&type=style&index=0&id=4d5db025&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5db025"]])

export default __exports__